export default __webpack_public_path__ + "static/media/60t.2dad72bc.jpg";